// src/components/icons/AudioLines.jsx
import React from 'react';

const AudioLines = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <style>
        {`
          @keyframes line-animation {
            0% { transform: scaleY(1); }
            50% { transform: scaleY(0.3); }
            100% { transform: scaleY(1); }
          }
          .audio-line {
            transform-origin: center;
            animation: line-animation infinite;
          }
          .line-1 { animation-duration: 0.7s; }
          .line-2 { animation-duration: 0.9s; }
          .line-3 { animation-duration: 0.8s; }
          .line-4 { animation-duration: 1s; }
          .line-5 { animation-duration: 0.6s; }
          .line-6 { animation-duration: 0.5s; }
        `}
      </style>
      <path className="audio-line line-1" d="M2 10v3" />
      <path className="audio-line line-2" d="M6 6v11" />
      <path className="audio-line line-3" d="M10 3v18" />
      <path className="audio-line line-4" d="M14 8v7" />
      <path className="audio-line line-5" d="M18 5v13" />
      <path className="audio-line line-6" d="M22 10v3" />
    </svg>
  );
};

export default AudioLines;
